import displayPrice from "@/displayPrice/displayPrice"
import localeConfig from "@/config/localeConfig"



export default class GreenThing { // singleton pattern
    #rootDiv;
    #rootSelector;
    #priceSelector;
    #textSelector;
    #loadingSelector;
    #seeLogementSelector;

    #textElement;
    #loadingElement;
    #logementElement;

    constructor(
        rootSelector="#green-thing",
        priceSelector=".green-thing-price", 
        textSelector=".green-thing-text", 
        loadingSelector=".green-thing-loading", 
        seeLogementSelector=".green-thing-seeLogement"
    ) {
        if (GreenThing.singleton) {
            return GreenThing.singleton
        }

        this.#rootSelector = rootSelector
        this.#priceSelector = priceSelector
        this.#textSelector = textSelector
        this.#loadingSelector = loadingSelector
        this.#seeLogementSelector = seeLogementSelector

        GreenThing.singleton = this
        return GreenThing.singleton
    }


    #setListeners() {
        global.addEventListener("planningStateRefreshed", ()=>{
            if (this.#isNeedToHideGreenThing()) { // show-hide depending on state of planner
                this.#rootDiv.classList.remove("d-md-block")
                return
            } else {
                this.#rootDiv.classList.add("d-md-block")
            }
            
            if (global.planningState.loading) {
                this.#setLoading(true)
            } else {
                this.#updatePrice()
                this.#setLoading(false)
            }
        }, {passive: true})

        this.#logementElement.addEventListener("click", ()=>{
            global.dispatchEvent(new CustomEvent("smoothScrollToSelector", { detail: {selector: "#tf-planning"} }))
        })
    }

    #isNeedToHideGreenThing() {
        const seAvailabilities = global.planningState.seAvailabilities
        const prestations = seAvailabilities && seAvailabilities.prestations
        const prestationsLength = prestations && prestations.length
        if (
            global.planningState.productUnavailable || 
            prestationsLength === 0
        ) {
            return true
        }
        return false
    }

    #setLoading(bool) {
        this.#loadingElement.style.display = bool ? "block" : "none"
        this.#textElement.style.display = bool ? "none" : "block"
    }

    #updatePrice() {
        const cheapestPrest = global.planningState["cheapestPrestation"] || null
        const lowestPrice = cheapestPrest && cheapestPrest["variants"][0]["pricePerLogement"] || null
        this.#setPrice(lowestPrice)
    }

    #setPrice(price) {
        if (!price) {
            this.#rootDiv.classList.remove("d-md-block")
            return
        }
        const priceElement = this.#rootDiv.querySelector(this.#priceSelector)
        this.#rootDiv.classList.add("d-md-block")
        const locale = localeConfig[document.querySelector("html").getAttribute('lang')]
        const prettyPrice = displayPrice(parseInt(price)*100, locale)
        priceElement.innerHTML = prettyPrice
        priceElement.parentElement.style.display = "block"
    }

    init() {
        this.#rootDiv = document.querySelector(this.#rootSelector)
        this.#textElement = this.#rootDiv.querySelector(this.#textSelector)
        this.#loadingElement = this.#rootDiv.querySelector(this.#loadingSelector)
        this.#logementElement = this.#rootDiv.querySelector(this.#seeLogementSelector)

        if (!this.#rootDiv) throw new Error("No root div exists for GreenThing")
        this.#setListeners()
    }
}